import {CalendarRange} from 'lucide-react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

import {
  DropdownMenuGroup,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu';

const WorkScheduleMenuSection = () => {
  const {t} = useTranslation();

  return (
    <DropdownMenuGroup>
      <DropdownMenuItem asChild>
        <Link className="flex items-center gap-2" to="/work-schedule">
          <CalendarRange className="size-4" />
          {t('Work schedule')}
        </Link>
      </DropdownMenuItem>
    </DropdownMenuGroup>
  );
};

export default WorkScheduleMenuSection;
